import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Settings } from '../settings';

@Injectable({providedIn: 'root'})
export class BasicAuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //Add authorization header only if the request is not for login and the targeted to API
        //This is to avoid adding the JWT token to the login request and angular artifacts requests
        // which is not required
        if (request.url.indexOf("api/users/login") === -1 && request.url.indexOf("api/") != -1 && request.url.indexOf("localhost:4200") ===-1) {
            // add authorization header with basic auth credentials if available
            const currentToken = localStorage.getItem('jwt');
            if (currentToken){
                request = request.clone({
                    setHeaders: {
                        jwt: currentToken || '',
                    }
                });
            }
            request = request.clone({
                withCredentials: true,
                headers: request.headers.set('X-Requested-With', 'XMLHttpRequest')
            });
        }
        return next.handle(request);
    }
}
